"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thumbnailTemplate = void 0;
var tslib_1 = require("tslib");
var thumbnail_dot_1 = (0, tslib_1.__importDefault)(require("./thumbnail.dot"));
var thumbnailTemplate = thumbnail_dot_1.default.default ? thumbnail_dot_1.default.default : thumbnail_dot_1.default;
exports.thumbnailTemplate = thumbnailTemplate;
//# sourceMappingURL=index.js.map